export default __webpack_public_path__ + "static/media/tsp.27019443.png";